export default __webpack_public_path__ + "static/81860-9bffbecd407921a6a4fa88c0175d21ed.jpg";